<template>
    <div class="container">
        <h1 class="title">
            GW2 Scratch tools
        </h1>
        <p class="subtitle">
            Analyzing data from arcdps encounter logs and making use of the official GW2 API
        </p>
        <div class="columns">
            <div class="column is-3">
                <b-menu :accordion="false">
                    <b-menu-list label="General">
                        <b-menu-item icon="information-outline" label="Summary"
                                     tag="router-link"
                                     :to="{name: 'tools-summary'}"
                                     :active="$route.name === 'tools-summary'"
                        />
                    </b-menu-list>
                    <b-menu-list label="Programs">
                        <b-menu-item icon="file-tree" label="arcdps Log Manager"
                                     tag="router-link"
                                     :to="{name: 'tools-manager'}"
                                     :active="$route.name === 'tools-manager'"
                        />
                    </b-menu-list>
                    <b-menu-list label="arcdps plugins">
                      <b-menu-item icon="calendar-check-outline" label="arcdps Clears"
                                   tag="router-link"
                                   :to="{name: 'tools-arcdps-clears'}"
                                   :active="$route.name === 'tools-arcdps-clears'"
                      />
                    </b-menu-list>
                    <b-menu-list label="Developer tools">
                        <b-menu-item icon="magnify" label="EVTC Inspector"
                                     tag="router-link"
                                     :to="{name: 'tools-inspector'}"
                                     :active="$route.name === 'tools-inspector'"
                        />
                        <b-menu-item icon="bookshelf" label="GW2Scratch.EVTCAnalytics"
                                     tag="router-link"
                                     :to="{name: 'tools-library'}"
                                     :active="$route.name === 'tools-library'"
                        />
                    </b-menu-list>
                </b-menu>
            </div>
            <div class="column">
                <router-view />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'tools',
        data() {
            return {
            }
        }
    }
</script>

<style>
</style>
